import React from "react";
import context from "../../lib/context.js";
import { Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import BlankOverlay from "./../shared/blank-overlay";

export default class TimecardListItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };

        this.getLink = this.getLink.bind(this);
        this.toggleSubmitTimecardDialog = this.toggleSubmitTimecardDialog.bind(this);
    }

    toggleSubmitTimecardDialog() {
        if (this.props.toggleSubmitTimecardDialog)
            this.props.toggleSubmitTimecardDialog(true);
    }

    getLink(vm) {
        if (vm.timecardSummary.timecardType === "DURATIONTC") {
             return context.routeUrl(`${this.props.role}/tc-duration/${vm.timecardSummary.timecardId}`);
        } else {            
            return context.routeUrl(`${this.props.role}/tc-clock-edit/${vm.timecardSummary.timecardId}`);
        }
    }

    render() {
        let vm = this.props.vm;            
        let tc = vm.timecardSummary;
        let preVerifiedClassName = "fa fa-calendar-check-o ap-blue-color " + (tc.imageFileName.toLowerCase().indexOf('/preverify.gif') > -1 ? "" : "ap-hidden");
        let totalHours = parseFloat(tc.totalHour) + (parseFloat(tc.totalMin) / 60);
        let editedClassName = "glyphicon glyphicon-edit ap-error-color " + (tc.isEdited ? "" : "ap-hidden"); 
        let chkBoxClassName= totalHours > 0 && tc.isEdited == false && 
            (
                tc.statusDescription.toLowerCase() == "submitted" || 
                // tc.statusDescription.toLowerCase() == "unsubmitted" || 
                (
                    this.props.role.toLowerCase() == 'supervisor' && 
                    tc.statusDescription.toLowerCase() == "verified" && 
                    tc.imageFileName.toLowerCase().indexOf('/preverify.gif') > -1
                )
            ) ? "" : "ap-hidden";
        let unapprovedPtoClassName = "fa fa-suitcase ap-error-color " + (tc.hasUnapprovedPto ? "" : "ap-hidden");
        
        const preVerifiedToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_preverified`} className="ap-tooltip">Pre-Verified by Payroll Admin</Tooltip>);
        const editedToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_edited`} className="ap-tooltip">Clock Entry has been edited</Tooltip>);
        const nonExemptStaffToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_nonExempt`} className="ap-tooltip">Non-Exempt Staff</Tooltip>);
        const submitReminderToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_submitReminder`} className="ap-tooltip">Send a reminder to submit</Tooltip>);
        const editToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_edit`} className="ap-tooltip">Edit</Tooltip>);
        let miscToolTip = <BlankOverlay id={`tooltip_${tc.timecardId}_misc`} />;
        const unapprovedPtoToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_unapprovedPto`} className="ap-tooltip">Unapproved Time-Off</Tooltip>);
        
        if (tc.expenses.length > 0) {
            miscToolTip = (<Tooltip id={`tooltip_${tc.timecardId}_misc`} className="ap-tooltip-big"><div className="ap-tooltip-container">{tc.expenses.map(function(exp, i) {
                return (<div key={i} className="ap-tooltip-item">{exp}</div>);
            })}</div></Tooltip>);
        } 
        
        let totalHoursIcon = <BlankOverlay id={`overlay_${tc.timecardId}_arrowup`} />;;
        
        if (totalHours > tc.weeklyHours) {
            totalHoursIcon = <div className="ap-tooltip-button-arrow-container"><OverlayTrigger id={`overlay_${tc.timecardId}_arrowup`}
                                placement="top"
                overlay={<Tooltip id={`tooltip_${tc.timecardId}_arrowup`} className="ap-tooltip">Greater than scheduled hours</Tooltip>}>
                                <Button className="ap-tooltip-button arrow">
                                    <span className="glyphicon glyphicon-arrow-up ap-red-color" /> 
                                </Button>
                            </OverlayTrigger></div>
        }
        else if (totalHours < tc.weeklyHours) {
            totalHoursIcon = <div className="ap-tooltip-button-arrow-container"><OverlayTrigger id={`overlay_${tc.timecardId}_arrowdown`}
                                placement="top"
                overlay={<Tooltip id={`tooltip_${tc.timecardId}_arrowdown`} className="ap-tooltip">Less than scheduled hours</Tooltip> }>
                                <Button className="ap-tooltip-button arrow">
                                    <span className="glyphicon glyphicon-arrow-down ap-red-color" /> 
                                </Button>
                            </OverlayTrigger></div>
        }

        const regularHourClassName = tc.regularHour != 0 || tc.regularMin ? "ap-color-darkgray" : "ap-color-gray";
        const otHourClassName = tc.otHour != 0 || tc.otMin != 0 ? "ap-color-darkgray" : "ap-color-gray";
        const tdHoursClassName = tc.dtHour != 0 || tc.dtMin != 0 ? "ap-color-darkgray" : "ap-color-gray";
        const miscHourClassName = tc.miscMin != 0 || tc.miscHour != 0 ? "ap-color-darkgray" : "ap-color-gray";
        const totalHourClassName = totalHours != 0 ? 'ap-color-darkgray' : 'ap-color-gray';   

        const editColumn = <div className={this.props.role == 'payroll-admin' ? "col-md-2 col-lg-2 text-center" : "col-md-2 col-lg-2"}>
                <div className="ap-icon pull-right">
                <OverlayTrigger id={`overlay_${tc.timecardId}_edit`}
                        placement="top"
                    overlay={editToolTip}>
                        <Button className="ap-tooltip-button">
                            <a href={this.getLink(vm)}>
                                <span className="glyphicon glyphicon-edit"/>
                            </a>
                        </Button>
                    </OverlayTrigger>
                </div>
                <div className="ap-icon pull-right ap-send-submit-timecard-icon">
                <OverlayTrigger id={`overlay_${tc.timecardId}_send_reminder`}
                        placement="top"
                    overlay={submitReminderToolTip}>
                        <Button className="ap-tooltip-button"
                            onClick={() => {
                                //if (tc.submitReminder == false) {
                                    this.props.toggleSubmitTimecardDialog(true, tc.timecardId, tc.peopleName);
                                //}
                            }}>
                            <div className={tc.statusCode.toLowerCase() == 'saved' ? '' : 'ap-hidden'}>
                                <img className="ap-timecard-list-icon" src={context.url("images", "SendReminder.png")} />
                                {
                                    tc.submitReminder == false || tc.statusCode.toLowerCase() != 'saved' ? null :
                                        <div className="ap-icon-footer">sent</div>
                                }
                            </div>
                        </Button>
                    </OverlayTrigger>
                </div>
            </div>;
        
        return(                        
            <div className={"row ap-timecard-list-item ap-timecard-list-item-new ap-no-padding-side " + tc.statusDescription.toLowerCase()}>
                <section className="hidden-sm hidden-xs">
                    <div className="col-md-1 col-lg-1 ap-pr-0">
                        <input className={chkBoxClassName} type="checkbox" 
                        checked={tc.isChecked === true} 
                        onChange={() => this.props.onChecked(tc.timecardId)}/>                    
                        <div className="ap-icon pull-right">
                            <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_edited`}
                                    placement="top"
                                    overlay={editedToolTip }>
                                    <Button className="ap-tooltip-button">
                                        <span className={editedClassName} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="ap-icon pull-right">
                            <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_nonexempt`}
                                    placement="top"
                                    overlay={nonExemptStaffToolTip }>
                                    <Button className="ap-tooltip-button">
                                        {
                                            tc.exemptType === "NONEXEMPT" ? <img className="ap-timecard-list-icon" src={context.url("images", "NonExempt.png")} /> : null
                                        }
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="ap-icon pull-right">
                            <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_preverify`}
                                    placement="top"
                                    overlay={preVerifiedToolTip }>
                                    <Button className="ap-tooltip-button">
                                        <span className={preVerifiedClassName} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="ap-icon pull-right">
                            <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_approvePto`}
                                    placement="top"
                                    overlay={unapprovedPtoToolTip }>
                                    <Button className="ap-tooltip-button">
                                        <span className={unapprovedPtoClassName} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2">
                        <a href={this.getLink(vm)}>
                            <span className="ap-person-name verify-timecard">{tc.peopleName}</span>
                        </a>
                    </div>
                    {
                        this.props.role.toLowerCase() == 'supervisor' ?
                            <div className="col-md-1 col-lg-1 ap-color-darkgray">
                                {
                                    vm.apId == '' ? '' : 
                                        <a href="#" data={`_${vm.apId}_${tc.peopleName}_${tc.staffCount}`} onClick={(event) => {
                                            event.preventDefault();
                                            this.props.onStaffChange(event.target.getAttribute('data'), this.props.onSearch);
                                            return false;
                                        } }>
                                            {tc.staffCount + ' Staff'}
                                        </a> 
                                }
                            </div> :
                            null
                    }
                    {
                        this.props.role.toLowerCase() == 'payroll-admin' ?
                            <div className="col-md-2 col-lg-2 ap-color-darkgray">
                                {tc.reportToName}
                            </div> :
                            null
                    }
                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                        <div className={tc.statusDescription.toLowerCase() == 'unsubmitted' ? 'ap-color-gray-italics' : '' }>{tc.statusDescription}</div>
                    </div>
                    <div className="col-md-1 col-lg-1 ap-color-darkgray">
                        {tc.placementId}
                    </div>
                    <div className={(this.props.role.toLowerCase() == 'supervisor' ? "col-md-6 col-lg-6" : "col-md-5 col-lg-5")}>
                        <div className={"col-md-2 col-lg-2 " + regularHourClassName}>
                            {tc.regularHour + "." + (parseFloat(tc.regularMin) / 60).toFixed(2).replace('0.', '')}
                        </div>
                        <div className={"col-md-2 col-lg-2 " + otHourClassName}>
                            {tc.otHour + "." + (parseFloat(tc.otMin) / 60).toFixed(2).replace('0.', '')}
                        </div>
                        <div className={"col-md-2 col-lg-2 " + tdHoursClassName}>
                            {tc.dtHour + "." + (parseFloat(tc.dtMin) / 60).toFixed(2).replace('0.', '')}
                        </div>
                        <div className="col-md-2 col-lg-2">
                            <OverlayTrigger id={`overlay_${tc.timecardId}_misc`}
                                placement="top"
                                overlay={miscToolTip}>
                                <Button className="ap-tooltip-button">
                                    <span className={miscHourClassName + ' ap-tooltip-button-text'}>{tc.miscHour + "." + (parseFloat(tc.miscMin) / 60).toFixed(2).replace('0.', '')}</span>
                                </Button>
                            </OverlayTrigger>
                        </div>  
                        <div className="col-md-2 col-lg-2">
                            <div className="ap-unwrap-content ap-timecard-list-item-total">
                                {totalHoursIcon}                      
                                <div className={"ap-total-hour pull-right " + totalHourClassName}>{totalHours.toFixed(2)}</div>
                            </div>
                        </div>
                        {editColumn}
                    </div>
                </section>
                <section className="hidden-md hidden-lg"> 
                    <div className="col-xs-6 col-sm-6">
                        <input className={chkBoxClassName} type="checkbox" 
                            checked={tc.isChecked === true} 
                            onChange={() => this.props.onChecked(tc.timecardId)} />
                        <div className="ap-icon">
                           <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_approvePto2`}
                                    placement="top"
                                    overlay={unapprovedPtoToolTip }>
                                    <Button className="ap-tooltip-button">
                                        <span className={unapprovedPtoClassName} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="ap-icon">
                           <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_preverify2`}
                                    placement="top"
                                    overlay={preVerifiedToolTip }>
                                    <Button className="ap-tooltip-button">
                                        <span className={preVerifiedClassName} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                         <div className="ap-icon">
                            <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_nonexempt2`}
                                    placement="top"
                                    overlay={nonExemptStaffToolTip }>
                                    <Button className="ap-tooltip-button">
                                        {
                                            tc.exemptType === "NONEXEMPT" ? <img className="ap-timecard-list-icon" src={context.url("images", "NonExempt.png")} /> : null
                                        }
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="ap-icon">
                           <div>
                                <OverlayTrigger id={`overlay_${tc.timecardId}_edited2`}
                                    placement="top"
                                    overlay={editedToolTip }>
                                    <Button className="ap-tooltip-button">
                                        <span className={editedClassName} />
                                    </Button>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <div className="ap-icon ap-send-submit-timecard-icon">
                            <OverlayTrigger id={`overlay_${tc.timecardId}_submit`}
                                placement="top"
                                overlay={submitReminderToolTip }>
                                <Button className="ap-tooltip-button"
                                    onClick={() => {
                                        // if (tc.submitReminder == false) {
                                            this.props.toggleSubmitTimecardDialog(true, tc.timecardId, tc.peopleName);
                                        // }
                                    }}>
                                    <div className={tc.statusCode.toLowerCase() == 'saved' ? '' : 'ap-hidden'}>
                                        {/* <div className="glyphicon glyphicon-envelope" /> */}
                                        <img className="ap-timecard-list-icon" src={context.url("images", "SendReminder.png")} />
                                        {
                                            tc.submitReminder == false || tc.statusCode.toLowerCase() != 'saved' ? null :
                                                <div className="ap-icon-footer">sent</div>
                                        }
                                    </div>
                                </Button>
                            </OverlayTrigger>
                        </div>
                        <div className="ap-icon">
                            <OverlayTrigger id={`overlay_${tc.timecardId}_edit2`}
                                placement="top"
                                overlay={editToolTip }>
                                <Button className="ap-tooltip-button">
                                    <a href={this.getLink(vm)}>
                                        <span className="glyphicon glyphicon-edit"/>
                                    </a>
                                </Button>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="col-xs-6 col-sm-6">
                            <a href={this.getLink(vm)}>
                                <span className="ap-person-name verify-timecard">{tc.peopleName}</span>
                            </a>
                        </div> 
                        <div className="col-xs-6 col-sm-6">
                            {
                                this.props.role.toLowerCase() == 'supervisor' ?
                                    vm.apId == '' ? '' : 
                                        <a href="#" data={`_${vm.apId}_${tc.peopleName}_${tc.staffCount}`} onClick={(event) => {
                                            event.preventDefault();
                                            this.props.onStaffChange(event.target.getAttribute('data'), this.props.onSearch);
                                            return false;
                                        }
                                        }>
                                            {tc.staffCount + ' Staff'}
                                        </a> :
                                    <div>
                                        <span className="ap-color-gray">Report To </span><br/>
                                        <b>{tc.reportToName}</b> 
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 ap-separator-col">              
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">Status </span><br/>
                        <b>{tc.statusDescription}</b>                      
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">{this.props.role.toLowerCase() == 'supervisor' ? 'ID' : 'Assign ID'}</span><br/>
                        <b>{tc.placementId}</b>
                    </div>  
                    <div className="col-xs-12 col-sm-12 ap-separator-col">              
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">Reg </span><br/>
                        <b>{tc.regularHour + "." + (parseFloat(tc.regularMin) / 60).toFixed(2).replace('0.', '')}</b>
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">OT </span><br/>
                        <b>{tc.otHour + "." + (parseFloat(tc.otMin) / 60).toFixed(2).replace('0.', '')}</b>
                    </div>
                    <div className="col-xs-12 col-sm-12 ap-separator-col">              
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">DT </span><br/>
                        <b>{tc.dtHour + "." + (parseFloat(tc.dtMin) / 60).toFixed(2).replace('0.', '')}</b>
                    </div>
                    <div className="col-xs-6 col-sm-6">
                        <span className="ap-color-gray">Misc </span><br/>
                        <OverlayTrigger id={`overlay_${tc.timecardId}_misc2`}
                            placement="top"
                            overlay={miscToolTip }>
                            <Button className="ap-tooltip-button">
                            <b><span className="ap-tooltip-button-text ap-color-darkgray">{tc.miscHour + "." + (parseFloat(tc.miscMin) / 60).toFixed(2).replace('0.', '')}</span></b>
                            </Button>
                        </OverlayTrigger>
                    </div>  
                    <div className="col-xs-12 col-sm-12 ap-separator-col">          
                    </div>
                    <div className="col-xs-12 col-sm-12">
                        <div className="ap-unwrap-content">
                            <span className="ap-color-gray">Total </span><br/>
                            {totalHoursIcon}              
                            <span className={"ap-total-hour " + (totalHoursIcon == null ? "" : "ap-total-hour-mobile")}><b>{totalHours.toFixed(2)}</b></span> 
                        </div>
                    </div>
                </section>
            </div>                           
        );
        
    }
}